import EntityEditForm from "../../../Components/Dashboard/EntityEditForm";
import { SUBJECT } from "../../../Api/Api";

export default function Ads() {
  return (
    <EntityEditForm
      fetchEndpoint={SUBJECT}
      saveEndpoint={SUBJECT}
      redirectPath="/dashboard/T_Ads"
    />
  );
}
